<template>
  <form-dialog ref="form-saveas" title="另存为模板" :data="data"  width="80%"
                 :visible.sync="visibleSync" :columns="columnList"
                 @confirm="SaveAs"></form-dialog>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `NarcoticsBoxTemplateSaveAs`,
    props: {
        visible: { type: Boolean, default: () => false },
        data: { type: Object }
    },
    data() {
        return {
            title: `备药模板另存为`
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`]),
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        columnList() {
            return [{
                type: `string`,
                prop: `name`,
                label: `名称`,
                colspan: 12,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `groupmultiselect`,
                prop: `dic_ward_ids`,
                label: `可用区域`,
                // width: "180",
                isListable: true,
                isEditable: true,
                isCreatable: true,
                colspan: 12,
                options: this.ward_auth
                // default:[this.dic_ward_id]
            }, {
                type: `table`,
                prop: `items`,
                label: `药品列表`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                }, {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `140`,
                    isListable: true,
                    readonly: false
                }, {
                    type: `remoteselect`,
                    prop: `dic_drug`,
                    label: `药品`,
                    width: `300`,
                    isListable: true,
                    readonly: false,
                    options: `/api/AcisSystem/Drug/Search`,
                    change: (that, { row, area }) => {
                        let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                        req.then(data => {
                            this.$set(row, `spec`, data && data.spec)
                            this.$set(row, `unit`, data && data.drug_unit)
                        })
                    }
                }, {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `120`,
                    isListable: true
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `数量`,
                    width: `140`,
                    isListable: true,
                    readonly: false,
                    default: 1
                }, {
                    type: `string`,
                    prop: `unit`,
                    label: `单位`,
                    width: `60`,
                    isListable: true
                }],
                colspan: 24,
                default: []
            }]
        }
    },
    methods: {
        saveOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/AcisSystem/NarcoticsBoxTemplate/Post`, {
                    'name': row.name,
                    'code': row.code,
                    'description': row.description,
                    // "display_order":row.display_order,
                    'regions': row.region_type == 1 ? [{ 'owner': this.currentUser.username }] : row.dic_ward_ids.map(d => {
                        return {
                            // "sys_supplies_template_id": 0,
                            'dic_operating_ward_id': _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            'dic_recovery_ward_id': _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    }),
                    'items': row.items.map(d => {
                        return {
                            'id': d.id,
                            'sys_narcotics_box_template_id': row.id,
                            'dic_drug_id': d.dic_drug.value,
                            'quantity': d.quantity
                        }
                    })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        SaveAs(row) {
            this.saveOne(row).then(data => {
                this.$emit(`save-success`)
                this.visibleSync = false
            })
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dictionary/NarcoticsBox/SaveAs.vue